setTimeout(function() {
    $('#blog-recommended_products').owlCarousel({
    autoplay:false,
    autoplayTimeout:4000,
    loop:true,
    mouseDrag:true,
    nav:true,
    dots: false,
    touchDrag: true,
    responsive:{
      0:{
        items:2
      },
      991:{
        items:3
      },
      1199:{
        items:4
      }
    }
  });

  $('#blog-recommended_products2').owlCarousel({
    autoplay:false,
    autoplayTimeout:4000,
    loop:true,
    mouseDrag:true,
    nav:true,
    dots: false,
    touchDrag: true,
    responsive:{
      0:{
        items:2
      },
      991:{
        items:3
      },
      1199:{
        items:4
      }
    }
  });
   $('#blog-recommended_products3').owlCarousel({
    autoplay:false,
    autoplayTimeout:4000,
    loop:true,
    mouseDrag:true,
    nav:true,
    dots: false,
    touchDrag: true,
    responsive:{
      0:{
        items:2
      },
      991:{
        items:3
      },
      1199:{
        items:4
      }
    }
  });
   $('#blog-recommended_products4').owlCarousel({
    autoplay:false,
    autoplayTimeout:4000,
    loop:true,
    mouseDrag:true,
    nav:true,
    dots: false,
    touchDrag: true,
    responsive:{
      0:{
        items:2
      },
      991:{
        items:3
      },
      1199:{
        items:4
      }
    }
  })

  	}
  ,1000);


  
  